module.exports = __webpack_public_path__ + "img/circularStrategy31.d23eec28.png";